
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { VisitsCategoriesUpdateRequestType } from "./visitsUpdate.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import { IVisitCategories, IVisitCategoriesListItem, VisitCategoriesResponseType } from '@/entity/visits/visitCategories.types';

@Component
export default class VisitsCategoriesUpdateForm extends Form {

    id: number | null = null;
    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    color: string | null = null;

    getFormData(): VisitsCategoriesUpdateRequestType {
       return{
            id: this.id,
            name: this.name,
            color: this.color,
       } 
    }

    setFormData(visit: IVisitCategoriesListItem): void {
        this.id = visit.id;
        this.name = visit.name;
        this.color = visit.color;
        console.clear();
        console.log(visit);
    }
}
